module.exports = __webpack_public_path__ + "img/vote-2.1e8ae63b.png";